import { isProd } from '@/config';

export const getEnvValue = <T>({ dev, prod }: { dev: T; prod: T }): T => (isProd() ? prod : dev);
